import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Importação de páginas
import Home from './pages/Home';
import Sobre from './pages/Sobre';
import Servicos from './pages/Servicos';
import Termos from './pages/Termos';
import Politica from './pages/Politica';
import Loader from './pages/Loader';
import Cadastro from './pages/Cadastro';
import Links from './pages/Links';
import NotFound from './pages/404';
import Vagas from './pages/Vagas';

// Componentes
import Header from './pages/components/Header';
import Footer from './pages/components/Footer';
import WhatsappButton from './pages/components/Whatsapp';
import CookiesPopup from './pages/components/CookiesPopup';
import NewHome from './pages/NewHome';

function App() {
    return (
        <Suspense>
            <Router>
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/sobre" element={<Sobre />} />
                    <Route path="/servicos" element={<Servicos />} />
                    <Route path="/termos" element={<Termos />} />
                    <Route path="/politica" element={<Politica />} />
                    <Route path="/cookies" element={<Politica />} />
                    <Route path="/loader" element={<Loader />} />
                    <Route path="/cadastro" element={<Cadastro />} />
                    <Route path="/links" element={<Links />} />
                    <Route path="/vagas" element={<Vagas />} />
                    <Route path="/new-home" element={<NewHome />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>

                <WhatsappButton />
                <CookiesPopup />
                <Footer />
            </Router>
        </Suspense>
    );
}

export default App;
